import * as React from 'react';

import Transfers140 from './Transfers140';

export const transfers140 = () => <Transfers140 />;

export default {
    title: 'Illustration/Transfers140',
    component: Transfers140,
    parameters: {
        notes: "`import Transfers140 from 'box-ui-elements/es/illustration/Transfers140';`",
    },
};
